import * as Sentry from '@sentry/react';

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,

    // Performance: 100% in dev, 20% in prod
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,

    // Session Replay: 0% normal, 100% on error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],

    tracePropagationTargets: ['localhost'],

    beforeSend(event) {
      // Ignore network errors (user offline)
      if (event.exception?.values?.[0]?.type === 'TypeError' &&
          event.exception?.values?.[0]?.value?.includes('Failed to fetch')) {
        return null;
      }
      return event;
    },
  });
}

/**
 * Associate errors with the current user after login
 */
export function setSentryUser(user: {
  id: string;
  email?: string;
  plan?: string;
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    ...(user.plan && { plan: user.plan }),
  });
}

/**
 * Clear user context on logout
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}

/**
 * Add a custom breadcrumb to trace user actions
 */
export function addSentryBreadcrumb(
  category: string,
  message: string,
  data?: Record<string, unknown>
) {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
    level: 'info',
  });
}
